import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { Router } from '@angular/router';
import { AnimationOptions } from 'ngx-lottie';
import { FaqsService } from 'src/app/services/faqs.service';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {


  loadingPage: boolean = false;

  @ViewChild('containerEvents', { static: false }) containerEvents: ElementRef;
  loadingLottie: AnimationOptions = {
    path: 'assets/lotties/loading.json',
  };

  @ViewChild(MatAccordion) accordion: MatAccordion;

  /** Lo que llega del gestor de contenidos, sin tocar. */
  allFaqs: any[] = [];
  /** Lo que se pinta: lo anterior pasado por el buscador. */
  faqs: any[] = [];
  search: string = '';

  isNotProfile = false;

  constructor(
    private faqService: FaqsService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (this.router.url === '/faqs') {
      this.isNotProfile = true;
    }
    this.loadingPage = true;
    this.faqService.getAllFAQs().subscribe((resp: any) => {
      this.allFaqs = resp || [];
      this.faqs = this.allFaqs;
      this.loadingPage = false;
    }, error => {
      this.loadingPage = false;
      console.error('Error loading FAQs:', error);
    });
  }

  /**
   * Busca en la pregunta y en la respuesta. La respuesta viene en HTML del
   * gestor de contenidos, así que se le quitan las etiquetas antes de
   * comparar: si no, escribir "p" o "strong" casaría con todas.
   */
  onSearch(value: string) {
    this.search = value;
    const texto = (value || '').trim().toLowerCase();

    if (!texto) {
      this.faqs = this.allFaqs;
      return;
    }

    this.faqs = this.allFaqs.filter(faq => {
      const pregunta = (faq?.acf?.question || '').toLowerCase();
      const respuesta = (faq?.acf?.descripcion || '').replace(/<[^>]*>/g, ' ').toLowerCase();
      return pregunta.includes(texto) || respuesta.includes(texto);
    });
  }

  clearSearch() {
    this.onSearch('');
  }

  goToContact() {
    this.router.navigate(['/contact']);
  }

  backTab() {
    this.router.navigate(['/profile']);
  }

}
